export enum VersionComparisonStatus {
    UpgradeAvailable = 0,
    LatestInRegion = 1,
    LatestGlobally = 2,
    NoPackages = 3
}
